import { Spinner } from '@change/ds-core-ui/Spinner';

import { withPrefetchedData } from '#src/shared/prefetch';

import type { SocialStarterPrefetchedDataProps } from '#src/app/pages/socialStarter/socialStarterDraft/pageContext';
import {
	prefetchPageContext,
	SocialStarterPageContextProvider,
} from '#src/app/pages/socialStarter/socialStarterDraft/pageContext';
import { TrackingShell } from '#src/app/shared/components/socialStarter';

import { Layout } from '../layout';

import { SocialStarterErrorHandler } from './ErrorHandler';

const SocialStarterPage = withPrefetchedData(
	function SocialStarterPage({ prefetchedData }: SocialStarterPrefetchedDataProps) {
		return (
			<TrackingShell version={3}>
				<SocialStarterPageContextProvider
					prefetchedData={prefetchedData}
					errorHandler={SocialStarterErrorHandler}
					loadingFallback={<Spinner className="mx-auto my-64" />}
				>
					<Layout />
				</SocialStarterPageContextProvider>
			</TrackingShell>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('corgi.start_a_petition.meta_tags.title')),
		pageMetadata: ({ i18n }) => ({
			description: i18n.translate('corgi.start_a_petition.meta_tags.description'),
			robots: 'noindex, nofollow',
		}),
	},
);

export { SocialStarterPage };
